var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.integration,
        title: _vm.$t("DELETE_PLATFORM_INTEGRATION_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("DELETE"),
        "confirm-button-disabled":
          _vm.isFetchingReferences ||
          _vm.isDeleting ||
          (_vm.references && !_vm.attest),
        "confirm-button-loading": _vm.isDeleting
      },
      on: { confirm: _vm.onConfirmDelete, close: _vm.onCloseDeleteModal }
    },
    [
      _vm.isFetchingReferences
        ? _c(
            "div",
            [
              _c("Loader", { attrs: { "custom-class": "size-sm" } }),
              _vm._v(" "),
              _c("i18n", {
                attrs: {
                  path:
                    "DELETE_PLATFORM_INTEGRATION_MODAL_CHECK_ASSOCIATION_TEXT",
                  tag: "span"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "items",
                      fn: function() {
                        return [
                          _c("strong", { staticClass: "f-s-13" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "DELETE_PLATFORM_INTEGRATION_MODAL_CHECK_ASSOCIATION_ITEMS"
                                )
                              )
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2200407672
                )
              })
            ],
            1
          )
        : _c(
            "div",
            [
              !_vm.references
                ? _c("i18n", {
                    attrs: {
                      path:
                        "DELETE_PLATFORM_INTEGRATION_MODAL_NONE_ASSOCIATION_TEXT",
                      tag: "p"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "integrationName",
                          fn: function() {
                            return [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.integrationName))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      945053844
                    )
                  })
                : _c("div", [
                    _c(
                      "p",
                      { staticClass: "m-b-10" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "DELETE_PLATFORM_INTEGRATION_MODAL_CONFIRM_QUESTION"
                              )
                            ) +
                            "\n        "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("i18n", {
                          attrs: {
                            path:
                              "DELETE_PLATFORM_INTEGRATION_MODAL_ASSOCIATION_TEXT",
                            tag: "span"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "integrationName",
                              fn: function() {
                                return [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.integrationName))
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "well well-sm m-b-10" }, [
                      _c("div", { staticClass: "form-horizontal" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "label",
                            { staticClass: "col-md-3 control-label" },
                            [_c("strong", [_vm._v("Campaigns")])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-8" }, [
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "list-unstyled form-control-static list-text-overflow"
                              },
                              _vm._l(_vm.references, function(item, index) {
                                return _c("li", { key: index }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `#/dashboard/campaign/${item.campaignId}`,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "display-text" },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(item.campaignName) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "fa fa-external-link m-l-5",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  )
                                ])
                              }),
                              0
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-horizontal m-l-10 m-r-10" },
                      [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.attest,
                                  expression: "attest"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.attest)
                                  ? _vm._i(_vm.attest, null) > -1
                                  : _vm.attest
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.attest,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.attest = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.attest = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.attest = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "DELETE_PLATFORM_INTEGRATION_CHECKBOX",
                                  expression:
                                    "'DELETE_PLATFORM_INTEGRATION_CHECKBOX'"
                                }
                              ]
                            })
                          ])
                        ])
                      ]
                    )
                  ])
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }